export const paymentTypeOptions = [
   { label: 'cash', value: 'CASH' },
   { label: 'payment_card', value: 'CREDIT_CARD' },
   { label: 'Blik', value: 'BLIK' },
   { label: 'gift_voucher', value: 'GIFT_VOUCHER' },
   { label: 'vat_invoice', value: 'VAT_INVOICE' },
   { label: 'Euro', value: 'PAYMENT_IN_EURO' },
];

export const accessToTheCustomerOptions = [{ label: 'drive_to_customer', value: 'true' }];

export const genderOptions = [
   { label: 'female', value: 'FEMALE' },
   { label: 'male', value: 'MALE' },
];

export const priceOptions = [
   { label: 'less_than_100', value: 'LESS_THAN_100' },
   { label: 'between_100_and_250', value: 'BETWEEN_100_AND_250' },
   { label: 'more_than_250', value: 'MORE_THAN_250' },
];

export const PRICE_OPTIONS = {
   LESS_THAN_100: 'LESS_THAN_100',
   BETWEEN_100_AND_250: 'BETWEEN_100_AND_250',
   MORE_THAN_250: 'MORE_THAN_250',
};

export const clientTypesOptions = [
   { label: 'women_2', value: 'WOMEN' },
   { label: 'pregnant_women_2', value: 'PREGNANT_WOMEN' },
   { label: 'men_2', value: 'MEN' },
   { label: 'couples_2', value: 'COUPLES' },
   { label: 'children', value: 'KIDS' },
];

export const salonTypesOptions = [
   { label: 'private_premises', value: 'PRIVATE_PROPERTY' },
   {
      label: 'classic_salon',
      value: 'CLASSIC',
      description: 'with_reception',
   },
   {
      label: 'intimate_salon',
      value: 'INTIMATE_LIVING_ROOM',
      description: 'no_reception',
   },
];

export const facilitateAccessOptions = [
   { label: 'facility_for_disabled', value: 'OBJECT_FOR_DISABLED_PEOPLE' },
   { label: 'english_speaking_guest_services', value: 'GUEST_SERVICE_IN_ENGLISH' },
];

export const PRICE_SEPARATOR_URL = '_';
